import { __rest } from 'tslib';

const appendMeasurement = (value) => {
    if (typeof value === 'undefined')
        return;
    if (typeof value === 'number')
        return `${value}px`;
    return value;
};
const extractMarginProps = (props) => {
    const { margin, mt, mr, mb, ml } = props, rest = __rest(props, ["margin", "mt", "mr", "mb", "ml"]);
    return {
        $margin: appendMeasurement(margin),
        $marginTop: appendMeasurement(mt),
        $marginRight: appendMeasurement(mr),
        $marginBottom: appendMeasurement(mb),
        $marginLeft: appendMeasurement(ml),
        rest,
    };
};
const extractPaddingProps = (props) => {
    const { padding, pt, pr, pb, pl } = props, rest = __rest(props, ["padding", "pt", "pr", "pb", "pl"]);
    return {
        $padding: padding,
        $paddingTop: pt,
        $paddingRight: pr,
        $paddingBottom: pb,
        $paddingLeft: pl,
        rest,
    };
};
const extractDimensionsProps = (props) => {
    const { width, height } = props, rest = __rest(props, ["width", "height"]);
    return {
        $width: appendMeasurement(width),
        $height: appendMeasurement(height),
        rest,
    };
};

export { extractDimensionsProps, extractMarginProps, extractPaddingProps };
//# sourceMappingURL=utils.js.map
